import { storeFiltro, keyFiltro, storeFiltroPesquisa, keyFiltroPesquisa } from './store/index';
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { key, store } from './store'
import "bootstrap/dist/css/bootstrap.min.css"
import './assets/scss/main.scss'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas);
import { fab } from '@fortawesome/free-brands-svg-icons';
library.add(fab);
import { far } from '@fortawesome/free-regular-svg-icons';
library.add(far);
import { dom } from "@fortawesome/fontawesome-svg-core";
import BootstrapVue3 from 'bootstrap-vue-3'


dom.watch();
const options = {
    confirmButtonColor: '#054c80',
    cancelButtonColor: '#a40000',
    // icon: 'success',
};

createApp(App)
.component('font-awesome-icon', FontAwesomeIcon)
.use(store,key)
.use(storeFiltro,keyFiltro)
.use(storeFiltroPesquisa,keyFiltroPesquisa)
.use(router)
.use(VueSweetalert2, options)
.use(BootstrapVue3)
.mount('#app')
